// src/utils/schemas/dominio.ts
import { z } from "zod";

// Schemas de domínio — fonte única de verdade de enums e formas compartilhadas de negócio.
// Consumidos por escrita.ts (entrada) e leitura.ts (saída), além de labels.ts.
// Não dependem de infraestrutura: mudam apenas se o negócio mudar.
export const especieSchema = z.enum(["cão", "gato"]);
export const sexoSchema = z.enum(["macho", "fêmea"]);

// Delta do Quill — forma do conteúdo da ficha clínica (fichas_clinicas.conteudo_json).
// Fonte única: escrita.ts valida na entrada (refine) e leitura.ts na saída.
// ⚠️ A allowlist de `attributes` espelha a toolbar de
// src/client/admin-animal-clinical-record.ts: ao habilitar/remover um formato
// no editor, atualize os dois lados juntos.
const quillOpSchema = z.strictObject({
  insert: z.string().min(1),
  attributes: z
    .strictObject({
      bold: z.literal(true),
      italic: z.literal(true),
      underline: z.literal(true),
      header: z.union([z.literal(1), z.literal(2), z.literal(3)]),
      list: z.enum(["ordered", "bullet"]),
      blockquote: z.literal(true),
      "code-block": z.literal(true),
    })
    .partial()
    .optional(),
});
export const quillDeltaSchema = z.strictObject({
  ops: z.array(quillOpSchema).min(1),
});
